import React, {useState, useEffect} from 'react';
import { styled } from "@mui/material/styles";
import { sanityClient } from "../../sanityClient";
import { PortableText } from "@portabletext/react";
import { sanityPortableTextComponents } from "../components/sanityPortableTextComponents";

const HeroBanner = styled("div")(({ theme }) => ({
  backgroundColor: "#FAE2CF",
  borderBottomLeftRadius: "24px",
  [theme.breakpoints.up(768)]: {
    borderBottomLeftRadius: "50px",
  },
}));

const CategoryTitle = styled("div")(({ theme }) => ({
  color: "#000 !important",
  fontSize: "32px !important",
  lineHeight: "1.2 !important",
  whiteSpace: "normal !important",
  fontFamily: "Helvetica Bold, sans-serif !important",
  fontWeight: "bold !important",
  margin: "0 0 1rem 0 !important",
  display: "block !important",
  textTransform: "none !important",
  [theme.breakpoints.up(768)]: {
    fontSize: "65px !important",
  },
  "&&&": {
    fontSize: "32px !important",
    [theme.breakpoints.up(768)]: {
      fontSize: "65px !important",
    },
  },
}));


  const AboutUsText = ({ aboutUs }) => {
    return (
      <div className="container-lg">
          <div className="mb-3" >
              <h2>{aboutUs.title}</h2>
          </div>
        {aboutUs?.body && (
          <PortableText value={aboutUs.body} components={sanityPortableTextComponents} />
        )}
      </div>
    );
  };

const AboutUs = () => {
    const [aboutUs, setAboutUs] = useState(null);


    const getAboutUs = async () => {
        const query = `*[_type == "aboutUs"] | order(sort asc) {
            title,
            body
        }`;
        const aboutUsData = await sanityClient.fetch(query);
        if(aboutUsData?.length > 0){
            setAboutUs(aboutUsData?.[0]);
        }else{
            setAboutUs(null);
        }
    };
    useEffect(() => {
        getAboutUs();
    }, []);

 
    return (
        <>
            <section className="my-4 my-md-5 px-3">
                <HeroBanner className="container-lg px-0">
                    <div className="row g-0">
                        <div className="col-md-6 offset-md-1 px-3">
                            <div className="py-4 py-md-5">
                                <CategoryTitle className="mb-3">
                                    About Us
                                </CategoryTitle>
                                <p>
                                    Learn about our journey, our mission, and the team behind Mockee.
                                    <br />
                                </p>
                            </div>
                        </div>
                        <div className="col-md-5 px-0">
                            <div className="h-100 d-flex justify-content-end" style={{ paddingRight: "30px" }}>
                                <img
                                    src="/assets/images/about_us.svg"
                                    alt="About Us"
                                    className="img-fluid h-100 mb-hidden object-fit-cover"
                                    style={{
                                        borderTopLeftRadius: "60px",
                                        width: "75%",
                                        objectFit: "contain",
                                        objectPosition: "right center",
                                        transform: "scaleX(-1)",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </HeroBanner>
            </section>
            <section className="terms-use py-4 py-md-5">
                <div className="container">
                {aboutUs?.body && (
                    <AboutUsText aboutUs={aboutUs} />
      )}
                </div>
            </section>
        </>
    );
};

export default AboutUs;